import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { siteBenefits } from "@/mocks/home";

export default function SiteCreation() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
                <img
                  src="https://storage.helloreaddy.io/project_files/9d609ae5-b03e-4dcf-a75d-08eaee046d5d/8c58096c-6a8b-472a-a0d5-9905f9649f54_compressed_criacao-de-sites.webp"
                  alt="Criação de site responsivo exibido em notebook, tablet e celular"
                  title="Criação de sites profissionais NXHOST — design responsivo"
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 -right-3 hidden rounded-xl border border-background-200 bg-background-50 p-4 sm:block animate-floaty">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className="ri-smartphone-line text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-[11px] text-foreground-500">100% responsivo</p>
                    <p className="text-sm font-semibold text-foreground-950">Mobile first</p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
                <i className="ri-layout-masonry-line" aria-hidden="true"></i>
                Criação de sites
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                Seu site pode ser muito mais do que um cartão de visitas.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">
                Criamos experiências digitais modernas para empresas que querem apresentar seus
                produtos, serviços e diferenciais de forma profissional.
              </p>

              <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {siteBenefits.map((benefit) => (
                  <li key={benefit} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-check-double-line text-primary-600" aria-hidden="true"></i>
                    {benefit}
                  </li>
                ))}
              </ul>

              <Link
                to="/sites"
                className="mt-9 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                Quero modernizar meu site
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}